
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";

interface AuthButtonsProps {
  onSignIn: () => void;
  onSignUp: () => void;
  isMobile?: boolean;
}

export default function AuthButtons({ onSignIn, onSignUp, isMobile = false }: AuthButtonsProps) {
  const { t } = useLanguage();
  
  if (isMobile) {
    return (
      <>
        <Button
          variant="ghost"
          className="block w-full justify-start py-2 text-base font-medium transition-colors hover:text-primary"
          onClick={onSignIn}
        >
          {t("nav.login")}
        </Button>
        <Button
          className="mt-2 w-full"
          onClick={onSignUp}
        >
          {t("nav.signup")}
        </Button>
      </>
    );
  }
  
  return (
    <>
      <Button variant="ghost" size="sm" onClick={onSignIn}>
        {t("nav.login")}
      </Button>
      <Button size="sm" onClick={onSignUp}>
        {t("nav.signup")}
      </Button>
    </>
  );
}
